export const CLOSE = "close";
export const NORMAL = "normal";
export const STOP_RULESET = "stopRuleset";
export const SKIP = "skip";